// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { useStoreDependency } from 'general-store';
import PropTypes from 'prop-types';
import { memo, useCallback, useMemo, useState, useEffect } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import { TimelineCollapsedContext } from 'crm-events-data';
import { SubjectDependency, TimelineStatusStore, CurrentOwnerContext, LegacyQueryParamsContext, TimelinePermissionsContext, TimelineAuthContext, TimelineActionHandlerContext, fetchInitialActivities } from 'crm-events-data';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import UserSettingsStore from 'crm_data/settings/UserSettingsStore';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import UserSettingsKeys from 'crm_data/settings/UserSettingsKeys';
import { SubjectContext } from 'crm-events-data';
import { ActiveTaskIdContext } from 'crm-timeline-tasks/queues/context/ActiveTaskIdContext';
import { AccessLevelContextProvider } from 'customer-data-properties/accessLevel/AccessLevelContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import { dispatchQueue } from 'crm_data/dispatch/Dispatch';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import { CONVERSATIONS_STORE_RESET_ON_RETURN_TO_TIMELINE } from 'crm_data/actions/ActionTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import { isLoading, LOADING } from 'crm_data/flux/LoadingStatus';
import TimelineContainerVirtualized from './TimelineContainerVirtualized';
import { useInjectSampleTimelineEventsForContact } from 'crm-events-data';
import { buildTypedMap } from 'crm-events-data/types';
import EngagementDeepLinkAsync from './EngagementDeepLinkAsync';
import { View } from 'foundations-components/transitional/components/View';
import { gate } from 'hub-http/gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const dependencies = {
  isCollapsedByDefault: {
    stores: [UserSettingsStore],
    deref: props => {
      if (props.isEngagementDeepLink) {
        return false;
      }

      /**
       * Due to a known bug in LazyKeyStore where falsy values are set to null, we currently negate the
       * user setting around whether or not the compact timeline is expanded by default.
       *
       * https://git.hubteam.com/HubSpot/CRM-Issues/issues/7980
       *
       * To prevent a larger refactor we negate the user setting so downstream isEventCollapsed and the
       * TimelineCollapsedContext behaves as expected. We still return undefined when the user setting
       * is also undefined to avoid jitter with values going from false to true as it's updated.
       */
      const isCollapsedByDefault = UserSettingsStore.get(UserSettingsKeys.IS_TIMELINE_EXPANDED_BY_DEFAULT);
      return isLoading(isCollapsedByDefault) ? LOADING : !isCollapsedByDefault;
    }
  }
};
const RecordTimelineRouter = ({
  activeTaskId,
  auth,
  currentOwnerId,
  currentUserCanCommunicate,
  currentUserCanEdit,
  objectType,
  postTimelineActionToRecord,
  subjectId,
  query = {}
}) => {
  var _ref;
  const [profileStartTime, setProfileStartTime] = useState();
  const isEngagementDeepLink = !!query.engagement;
  useEffect(() => {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
    setProfileStartTime(performance.now());
  }, [setProfileStartTime]);
  const subject = useStoreDependency(SubjectDependency, {
    objectType,
    subjectId
  });
  const isCollapsedByDefault = useStoreDependency(dependencies.isCollapsedByDefault, {
    isEngagementDeepLink
  });
  const [shouldForceActivityTabForBET, setShouldForceActivityTabForBET] = useState(false);
  const hasTimelineEvents = useStoreDependency({
    stores: [TimelineStatusStore],
    deref: () => {
      const status = TimelineStatusStore.get('timelineStatus');
      return status && !!status.get('events');
    }
  });
  useInjectSampleTimelineEventsForContact({
    objectType,
    subject,
    ownerId: currentOwnerId || -1,
    isUngatedForSampleEventsDeprecation: (_ref = auth.gates && (auth.gates.includes('SampleEngagements') || auth.gates.includes(gate('hs-crm-events-backend:sample-engagements')))) !== null && _ref !== void 0 ? _ref : false
  });
  const handleShowFullTimeline = useCallback(() => {
    setShouldForceActivityTabForBET(true);
    // It's possible to get into a state where there are no timeline events nor are
    // we fetching timeline events – this is usually an indication that the timeline
    // stores have cleared their contents on navigation. Thus, there are no events in
    // those stores nor in the timeline, so we have to manually re-fetch them here
    if (!hasTimelineEvents) {
      const apiState = buildTypedMap({
        subjectId,
        objectType,
        TIMELINE_ITEM_LIMIT: 20
      });
      fetchInitialActivities(apiState);
    }
    dispatchQueue(CONVERSATIONS_STORE_RESET_ON_RETURN_TO_TIMELINE);
  }, [hasTimelineEvents, objectType, subjectId]);
  const timelineContents = useMemo(() => {
    if (isEngagementDeepLink) {
      return /*#__PURE__*/_jsx(View, {
        paddingInline: "400",
        paddingBlockEnd: "800",
        as: "div",
        children: /*#__PURE__*/_jsx(EngagementDeepLinkAsync
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        , {
          engagementId: +query.engagement,
          onShowFullTimeline: handleShowFullTimeline,
          profileStartTime: profileStartTime,
          source: query.source
        })
      });
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(TimelineContainerVirtualized, {
        forceActivityTabForBET: shouldForceActivityTabForBET,
        objectType: objectType,
        scopes: auth && auth.user ? auth.user.scopes : [],
        subject: subject,
        subjectId: subjectId
      })
    });
  }, [isEngagementDeepLink, shouldForceActivityTabForBET, objectType, auth, subject, subjectId, query.engagement, query.source, handleShowFullTimeline, profileStartTime]);
  const permissions = useMemo(() => {
    return {
      currentUserCanCommunicate,
      currentUserCanEdit
    };
  }, [currentUserCanCommunicate, currentUserCanEdit]);
  const subjectContextData = useMemo(() => {
    return {
      objectType,
      subjectId
    };
  }, [objectType, subjectId]);
  return /*#__PURE__*/_jsx(SubjectContext.Provider, {
    value: subjectContextData,
    children: /*#__PURE__*/_jsx(TimelinePermissionsContext.Provider, {
      value: permissions,
      children: /*#__PURE__*/_jsx(CurrentOwnerContext.Provider, {
        value: currentOwnerId || -1,
        children: /*#__PURE__*/_jsx(TimelineAuthContext.Provider, {
          value: auth,
          children: /*#__PURE__*/_jsx(TimelineCollapsedContext.Provider, {
            value: isCollapsedByDefault,
            children: /*#__PURE__*/_jsx(LegacyQueryParamsContext.Provider, {
              value: query,
              children: /*#__PURE__*/_jsx(ActiveTaskIdContext.Provider, {
                value: activeTaskId,
                children: /*#__PURE__*/_jsx(TimelineActionHandlerContext.Provider, {
                  value: postTimelineActionToRecord,
                  children: /*#__PURE__*/_jsx(AccessLevelContextProvider, {
                    children: /*#__PURE__*/_jsx(View, {
                      "data-onboarding": "record-timeline",
                      "data-selenium-test": "record-timeline",
                      blockSize: "100%",
                      "data-sizing-selector": "record-timeline",
                      children: timelineContents
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};
RecordTimelineRouter.propTypes = {
  activeTaskId: PropTypes.number,
  auth: PropTypes.object.isRequired,
  currentOwnerId: PropTypes.number,
  currentUserCanCommunicate: PropTypes.bool,
  currentUserCanEdit: PropTypes.bool,
  objectType: AnyCrmObjectTypePropType.isRequired,
  postTimelineActionToRecord: PropTypes.func.isRequired,
  query: PropTypes.shape({
    interaction: PropTypes.string,
    engagement: PropTypes.string
  }),
  subjectId: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(RecordTimelineRouter);